import React from 'react'
import styled from 'styled-components'

const Block = styled.footer`
  background: none;
  padding: 0 ${({ theme }) => theme.space[0]};
`

const Nav = styled.nav`
  height: 56px;
  max-width: 1160px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 24px;
    height: 24px;
    background: none;
  }

  path {
    fill: #000};
  }

  a {
    color: ${({ theme }) => theme.colors.secondary};

    :hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`

const Footer = () => {

  return (
    <Block>
      <Nav>
          {/* <Button key={link.id} url={link.url} style={{ margin: 15, background: "none" }}> */}
          {/*  <SVG src={link.icon} /> */}
          {/* </Button> */}
      </Nav>
    </Block>
  )
}

export default Footer
